import React, { ReactElement, ReactNode } from 'react';

interface CardPaddingProps {
  children: ReactNode;
}

export function CardPadding({ children }: CardPaddingProps): ReactElement {
  return <div className="p-3">{children}</div>;
}
